module.exports = __webpack_public_path__ + "img/download-android-200x66.e6608dc1.png";